/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ walkIn: NonNullable<unknown> }} Customer_Walk_In_FallbackInputs */

const vi_customer_walk_in_fallback = /** @type {(inputs: Customer_Walk_In_FallbackInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chưa chọn khách → tính là ${i?.walkIn}`)
};

/**

* @param {Customer_Walk_In_FallbackInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_walk_in_fallback = /** @type {((inputs: Customer_Walk_In_FallbackInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Walk_In_FallbackInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_walk_in_fallback(inputs)
});